import { Component, HostListener, OnInit, isDevMode } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WhitelabelService } from './services/whitelabel.service';
import { ConfigService } from './services/config.service';
import { SecurityService } from './services/security.service';
import { InterComunicacionService } from './services/communications/intercommservice';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { SignalRService } from './services/communications/signalr.service';
import { environment } from 'src/environment/environment';


@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: string | undefined = 'Remote Eye';
  touchStartY: number | undefined;
  swipeDifferenceThreshold: number = 100;


  constructor(private translate: TranslateService, private whitelabelService: WhitelabelService, private configurationService: ConfigService, private securityService: SecurityService, private interComService: InterComunicacionService,
    private signalRService: SignalRService, private router: Router) {
    this.translate.addLangs(['es', 'en', 'it']);
  }

  ngOnInit() {
    console.log("isDevMode", isDevMode());

    const urlPath = window.location.pathname.slice(1);
    const urlToken = urlPath.length === environment.tinyTokenLength ? urlPath : new URLSearchParams(window.location.search).get('token');

    const token = urlToken ?? this.securityService.getUrlToken();
    if (token != null) {
      console.log("save token", token);
      this.securityService.saveUrlToken(token);
      localStorage.setItem('token', token);
    }

    this.signalRService.unRegisterEvents();

    this.whitelabelService.initService();
    // Suscribirse a los cambios en el servicio WhitelabelService
    this.whitelabelService.currentWhitelabelObservable.subscribe((whitelabel) => {
      if (whitelabel != '') {
        this.title = this.whitelabelService.getCurrentAppName();
      }
    });

    if (!this.translate.langs.includes(this.configurationService.language)) {
      console.log(`Language not supported: ${this.configurationService.language}, set to English`);
      this.configurationService.changeLanguage('en');
    }

    this.translate.use(this.configurationService.language);
    this.translate.setDefaultLang(this.configurationService.language);
    this.updateFirebaseServiceWorker();

    console.log("appComponent - token", token);
    const target = token ? `/${token}` : '';

    console.log("target y url", target, this.router.url);
    if (target && this.router.url !== target) {
      console.log('Navigating to token route:', target);
      this.router.navigate([target]);
    }
  }

  private updateFirebaseServiceWorker() {
    this.notifyStateToFirebaseSW(document.visibilityState === 'visible'); //Primera vez que se abre

    document.addEventListener('visibilitychange', () => {
      this.notifyStateToFirebaseSW(document.visibilityState === 'visible');
    });
  }

  private notifyStateToFirebaseSW(isForeground: boolean) {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'VISIBILITY',
        isForeground
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    console.log("Event: ", $event)
    const confirmationMessage = this.translate.get('LEAVE_MESSAGE');
    $event.returnValue = confirmationMessage;
  }

  @HostListener('window:touchstart', ['$event'])
  touchStartNotification($event: any): void {
    this.touchStartY = $event.changedTouches[0].screenY;
  }

  @HostListener('window:touchend', ['$event'])
  touchEndNotification($event: any): void {
    let diference = this.touchStartY! - $event.changedTouches[0].screenY;
    console.log("Diference: ", diference);
    if (diference < 0 && Math.abs(diference) > this.swipeDifferenceThreshold) {
      console.log("Swipe Down");
      this.interComService.swipeUp();
    }
    this.touchStartY = 0;
  }
}


